import { UITourPulserAnimate } from './UITourPulserElements';
import { usePulserOverlay } from '../hooks/pulser';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Use SVG animate tag to animate d attribute of path (overlay and highlighted border)
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/SVG/Element/animate}
 */
const UITourPulserOverlay = ({
  className,
  enablePulse,
  pulserDuration,
  pulserOverlayColor,
  pulserRef
}) => {
  const overlayPath = usePulserOverlay(pulserRef);
  if (!overlayPath) {
    return null;
  }
  const {
    start,
    end
  } = overlayPath;
  return /*#__PURE__*/_jsx("path", {
    className: className,
    d: start,
    fill: pulserOverlayColor,
    onClickCapture: event => {
      // Prevent unexpected click events bubbling up to the window
      // For example: clicking the overlay should not close the target select
      event.stopPropagation();
    },
    children: enablePulse && /*#__PURE__*/_jsx(UITourPulserAnimate, {
      duration: pulserDuration,
      values: `${start};${end};${start}`
    })
  });
};
export default UITourPulserOverlay;